export default __webpack_public_path__ + "static/media/IMG_2085.67491d88.jpg";